import React from 'react';
import FormMentionEditor from '../../Component/FormMentionEditor';
import PropTypes from 'prop-types';

const TextValidation = ({ validation = {}, onChange, assignTask, availablePlaceholders }) => {
  const commonMentionEditorProps = {
    style: {
      width: '100%',
      verticalAlign: 'top',
      minHeight: '16px',
    },
    assignTask,
    hideScrollBar: true,
    onFocus: e => {},
    ...(availablePlaceholders != null && {
      availablePlaceholders: availablePlaceholders,
    }),
  };

  return (
    <>
      <p className="m-t-0 m-b-0">
        Validation: <span className="s-text"> enter Regex to check if answer is valid</span>
      </p>
      <FormMentionEditor
        {...commonMentionEditorProps}
        placeholder="Enter Regex"
        text={validation?.regex || ''}
        label="Regex"
        value={validation?.regex || ''}
        onChange={val => {
          onChange({ ...validation, regex: val });
        }}
      />
      <p className="m-b-0">
        Message: <span className="s-text">enter message to display if answer is invalid</span>
      </p>
      <FormMentionEditor
        {...commonMentionEditorProps}
        placeholder="Enter validation message"
        text={validation?.message || ''}
        label="Message"
        value={validation?.message || ''}
        onChange={val => {
          onChange({ ...validation, message: val });
        }}
      />
    </>
  );
};

TextValidation.propTypes = {
  validation: PropTypes.shape({
    regex: PropTypes.string,
    message: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  assignTask: PropTypes.bool,
  availablePlaceholders: PropTypes.array,
};

export default TextValidation;
